import React, { useState } from 'react';
import InputRange from 'react-input-range';

/**
 * A version of react-input-range that deounce the onChange callback
 * to avoid to many calls to the server
 */
const InputRangeDebounced = ({
  range,
  minValue,
  maxValue,
  value,
  onChange,
  disabled,
  step,
}) => {
  const [actualValue, setValue] = useState(value);

  // use minValue and maxValue is deprecated
  // use range instead
  if (!range) range = { min: minValue, max: maxValue };

  return (
    <InputRange
      minValue={range.min}
      maxValue={range.max}
      value={actualValue}
      onChange={setValue}
      onChangeComplete={onChange}
      disabled={disabled}
      step={step}
    />
  );
};

export default InputRangeDebounced;
